export enum STATUT {
    STT_REC_CODE = 'STT_REC',
    STT_IRR_CODE = 'STT_IRR',
    STT_REF_CODE = 'STT_REF',
    STT_ACCE_CODE = 'STT_ACCE',
    STT_ACCIM_CODE = 'STT_ACCIM',
    STT_ACCIA_CODE = 'STT_ACCIA',

}
